import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "border-white bg-white border w-full max-w-lg m-auto p-5 rounded" }
const _hoisted_2 = ["textContent"]
const _hoisted_3 = { class: "w-full" }
const _hoisted_4 = { class: "pb-6 text-sm" }
const _hoisted_5 = ["textContent"]
const _hoisted_6 = {
  key: 1,
  class: "border border-gray-400 bg-white flex flex-row"
}
const _hoisted_7 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_Prompt = _resolveComponent("Prompt")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_v_otp_input = _resolveComponent("v-otp-input")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass([{'hidden':!_ctx.Loading}])
    }, [
      _createVNode(_component_Loading, { inner: "" })
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["bg-theme-primary w-full max-w-xl h-screen m-auto flex", [{'hidden':_ctx.Loading}]])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_Prompt, {
          id: "message",
          onClosed: _ctx.closed,
          onPositiveClick: _ctx.send,
          title: "Reset OTP",
          message: "Are you sure you want to request for a new voter one time pin.",
          display: _ctx.prompt
        }, null, 8, ["onClosed", "onPositiveClick", "display"]),
        _createVNode(_component_Modal, {
          id: "modal_msg",
          onClosed: _ctx.closedPrompt,
          negativeButton: _ctx.lang('ok'),
          display: _ctx.alert.show,
          title: _ctx.alert.title
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "p-2 leading-5",
              textContent: _toDisplayString(_ctx.alert.message)
            }, null, 8, _hoisted_2)
          ]),
          _: 1
        }, 8, ["onClosed", "negativeButton", "display", "title"]),
        _createElementVNode("div", _hoisted_3, [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "pb-6 text-justify italic" }, " Please enter the one time pin we have sent to your email or mobile number before you proceed. ", -1)),
          _createElementVNode("div", _hoisted_4, [
            (_ctx.email != null)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["border border-gray-400 bg-white flex flex-row", { 'border-b-0': _ctx.mobile != null }])
                }, [
                  _cache[1] || (_cache[1] = _createElementVNode("div", { class: "p-2 font-bold contact-w border-r border-r-gray-400 uppercase" }, "Email", -1)),
                  _createElementVNode("div", {
                    class: "p-2 flex-grow text-gray-500 truncate",
                    textContent: _toDisplayString(_ctx.email)
                  }, null, 8, _hoisted_5)
                ], 2))
              : _createCommentVNode("", true),
            (_ctx.mobile != null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _cache[2] || (_cache[2] = _createElementVNode("div", { class: "p-2 font-bold contact-w border-r border-r-gray-400 uppercase" }, "Mobile", -1)),
                  _createElementVNode("div", {
                    class: "p-2 flex-grow text-gray-500 truncate",
                    textContent: _toDisplayString('+639'+_ctx.mobile)
                  }, null, 8, _hoisted_7)
                ]))
              : _createCommentVNode("", true)
          ]),
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "pb-2 font-bold uppercase" }, " Enter OTP ", -1)),
          _withDirectives(_createVNode(_component_v_otp_input, {
            "is-disabled": false,
            ref: "otp_email",
            class: "pb-2",
            "input-classes": "otp-input-election",
            conditionalClass: ['1', '2', '3', '4', '5', '6'],
            separator: " ",
            "input-type": 'number',
            inputmode: "numeric",
            "num-inputs": 6,
            onOnChange: _ctx.handleOnChangePin,
            onOnComplete: _ctx.handleOnCompleteEmail,
            value: _ctx.otp_email,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.otp_email) = $event)),
            "should-auto-focus": true,
            "should-focus-order": true,
            placeholder: ['*', '*', '*', '*', '*', '*']
          }, null, 8, ["onOnChange", "onOnComplete", "value"]), [
            [_vShow, true]
          ]),
          _createVNode(_component_Button, {
            id: "verf",
            button_text: 'Verify',
            class: "mb-2",
            onClick: _ctx.verifyOTP,
            rounded: ""
          }, null, 8, ["onClick"]),
          _createVNode(_component_Button, {
            id: "req",
            button_text: 'Request for new OTP',
            theme: "warning",
            onClick: _ctx.resend,
            rounded: ""
          }, null, 8, ["onClick"])
        ])
      ])
    ], 2)
  ], 64))
}